import PropTypes from 'prop-types';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { getPrice } from '../../../../../utils/formatters';

const PayOffTableRow = ({ onCheckClick, rowData, id }) => {
  const {
    totalContractValue,
    purchaserOPI,
    purchaserName,
    location,
    contractNumber,
    addendumStatus,
  } = rowData;

  return (
    <tr key={id}>
      <td>
        <p className="contract-number">{contractNumber}</p>
        {addendumStatus === ADDENDUM_IN_PROGRESS && (
          <p className="addendum-note">Note: Addendum In Progress</p>
        )}
      </td>
      <td>{purchaserOPI}</td>
      <td>{purchaserName}</td>
      <td>{location}</td>
      <td>{getPrice(totalContractValue)}</td>
      <td onClick={() => onCheckClick(contractNumber)} className="pay-off-check">
        CHECK
      </td>
    </tr>
  );
};

PayOffTableRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string,
    purchaserOPI: PropTypes.string,
    location: PropTypes.string,
    contractNumber: PropTypes.string,
    addendumNumber: PropTypes.string,
    addendumStatus: PropTypes.string,
    totalContractValue: PropTypes.number,
  }).isRequired,
  id: PropTypes.number.isRequired,
  onCheckClick: PropTypes.func.isRequired,
};

export default PayOffTableRow;
